// extracted by mini-css-extract-plugin
export var highlightOriginal = "_5y-0";
export var highlightSuggested = "_5y-1";